module.exports = __webpack_public_path__ + "img/a1-s34.ec959a7d.jpg";